var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBidCreditProtectection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 59,
    rx: 12,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.5L21 23V29.5C21 33 24.5 38.5 29 39.5C33.5 38.5 37 33 37 29.5V23L29 19.5H30Z",
    stroke: "url(#paint0_linear_830_10616)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_830_10616",
    x1: 21,
    y1: 29.5,
    x2: 37,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidCreditProtectection);
export default __webpack_public_path__ + "static/media/BidCredit Protectection.111ba2eb892b2e6455d819e9d75ca7f5.svg";
export { ForwardRef as ReactComponent };